export default "__VITE_ASSET__B1sLuMg6__"